import { render, staticRenderFns } from "./ModalProjectEdit.vue?vue&type=template&id=46432f84&lang=pug"
import script from "./ModalProjectEdit.vue?vue&type=script&lang=js"
export * from "./ModalProjectEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectEdit.vue?vue&type=style&index=0&id=46432f84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports